import "./Home.module.css";
import NexoNavigation from "@/reusable_sections/Header";
import PensacolasClimateExperts from "./sections/PensacolasClimateExperts";
import OurCoreExpertise from "./sections/OurCoreExpertise";
import AdvancedHvacTechnology from "./sections/AdvancedHvacTechnology";
import TheNexoCorePlatform from "./sections/TheNexoCorePlatform";
import SuccessInTheField from "./sections/SuccessInTheField";
import ImmediateTechnicalSupport from "./sections/ImmediateTechnicalSupport";
import GlobalFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NexoNavigation />
      <PensacolasClimateExperts />
      <OurCoreExpertise />
      <AdvancedHvacTechnology />
      <TheNexoCorePlatform />
      <SuccessInTheField />
      <ImmediateTechnicalSupport />
      <GlobalFooter />
    </div>;
}